module.exports = __webpack_public_path__ + "img/logo.f08dce2a.png";